import { useEffect } from 'react';

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

let scriptRequested = false;

function normalizeClientId(value: unknown) {
  const clientId = String(value ?? '').trim();
  return /^ca-pub-\d+$/.test(clientId) ? clientId : '';
}

function loadAdSense(clientId: string) {
  if (!clientId) return;
  let accountMeta = document.head.querySelector<HTMLMetaElement>('meta[name="google-adsense-account"]');
  if (!accountMeta) {
    accountMeta = document.createElement('meta');
    accountMeta.name = 'google-adsense-account';
    document.head.appendChild(accountMeta);
  }
  accountMeta.content = clientId;
  if (
    scriptRequested ||
    document.querySelector('script[data-nexhance-adsense="true"]') ||
    document.querySelector('script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]')
  ) return;
  scriptRequested = true;
  const script = document.createElement('script');
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(clientId)}`;
  script.dataset.nexhanceAdsense = 'true';
  document.head.appendChild(script);
}

export function AdSenseSlot({ slot, label = 'Advertisement' }: { slot: string; label?: string }) {
  const clientId = normalizeClientId(import.meta.env.VITE_ADSENSE_CLIENT_ID);
  const normalizedSlot = String(slot ?? '').trim();
  const configured = Boolean(clientId && /^\d+$/.test(normalizedSlot));

  useEffect(() => {
    if (!configured) return;
    loadAdSense(clientId);
    try {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({});
    } catch {
      // Ad blockers and delayed script loading can prevent initialization.
    }
  }, [clientId, configured]);

  if (!configured) return null;

  return (
    <aside className="content-ad-slot" aria-label={label}>
      <span>{label}</span>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={clientId}
        data-ad-slot={normalizedSlot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </aside>
  );
}
